/**
 * Daily price list files (cjenik), written to Firebase Storage by the
 * `dailyPriceList` function in `functions/`. Storage rules make `cjenik/`
 * publicly readable; the site serves the files under its own domain
 * (`/cjenik/<file>`) because the law asks for them on the trader's website.
 * The browser never calls Storage: the site's CSP and the bucket's CORS
 * settings don't allow it, so the list loads through a server function.
 */
import { createServerFn } from "@tanstack/react-start";

const BUCKET = "postolar-varga-webshop-e77a1.firebasestorage.app";

export type PriceListFile = {
  name: string;
  number: number;
  publishedAt: string;
};

export const priceListStorageUrl = (path: string) =>
  `https://firebasestorage.googleapis.com/v0/b/${BUCKET}/o/${encodeURIComponent(`cjenik/${path}`)}?alt=media`;

async function fetchPriceListFiles(): Promise<Array<PriceListFile>> {
  const res = await fetch(priceListStorageUrl("index.json"));
  // No file yet before the first run.
  if (res.status === 404) return [];
  if (!res.ok) throw new Error(`Price list index: ${res.status}`);
  const index = (await res.json()) as { files: Array<PriceListFile> };
  return index.files;
}

export const getPriceListFiles = createServerFn({ method: "GET" }).handler(
  fetchPriceListFiles,
);
